/**
 * Supported timezones for the application.
 * Focused on DACH region (Germany, Austria, Switzerland) and common European timezones.
 */
export const SUPPORTED_TIMEZONES = [
  { value: 'Europe/Berlin', label: 'Deutschland (MEZ/MESZ)', labelEn: 'Germany (CET/CEST)' },
  { value: 'Europe/Vienna', label: 'Österreich (MEZ/MESZ)', labelEn: 'Austria (CET/CEST)' },
  { value: 'Europe/Zurich', label: 'Schweiz (MEZ/MESZ)', labelEn: 'Switzerland (CET/CEST)' },
  { value: 'Europe/Amsterdam', label: 'Niederlande (MEZ/MESZ)', labelEn: 'Netherlands (CET/CEST)' },
  { value: 'Europe/Brussels', label: 'Belgien (MEZ/MESZ)', labelEn: 'Belgium (CET/CEST)' },
  { value: 'Europe/Paris', label: 'Frankreich (MEZ/MESZ)', labelEn: 'France (CET/CEST)' },
  { value: 'Europe/Rome', label: 'Italien (MEZ/MESZ)', labelEn: 'Italy (CET/CEST)' },
  { value: 'Europe/Madrid', label: 'Spanien (MEZ/MESZ)', labelEn: 'Spain (CET/CEST)' },
  { value: 'Europe/London', label: 'Großbritannien (GMT/BST)', labelEn: 'United Kingdom (GMT/BST)' },
  { value: 'Europe/Warsaw', label: 'Polen (MEZ/MESZ)', labelEn: 'Poland (CET/CEST)' },
  { value: 'Europe/Prague', label: 'Tschechien (MEZ/MESZ)', labelEn: 'Czech Republic (CET/CEST)' },
  { value: 'Europe/Copenhagen', label: 'Dänemark (MEZ/MESZ)', labelEn: 'Denmark (CET/CEST)' },
  { value: 'Europe/Stockholm', label: 'Schweden (MEZ/MESZ)', labelEn: 'Sweden (CET/CEST)' },
  { value: 'Europe/Oslo', label: 'Norwegen (MEZ/MESZ)', labelEn: 'Norway (CET/CEST)' },
  { value: 'Europe/Helsinki', label: 'Finnland (OEZ/OESZ)', labelEn: 'Finland (EET/EEST)' },
  { value: 'Europe/Athens', label: 'Griechenland (OEZ/OESZ)', labelEn: 'Greece (EET/EEST)' },
  { value: 'Europe/Lisbon', label: 'Portugal (WEZ/WESZ)', labelEn: 'Portugal (WET/WEST)' },
] as const;

/**
 * Default timezone used when none is specified.
 */
export const DEFAULT_TIMEZONE = 'Europe/Berlin';

/**
 * Type for supported timezone values.
 */
export type SupportedTimezone = (typeof SUPPORTED_TIMEZONES)[number]['value'];

/**
 * Get the localized label for a timezone.
 * @param timezone IANA timezone identifier
 * @param locale 'de' or 'en'
 * @returns Localized label or the timezone itself if not found
 */
export function getTimezoneLabel(timezone: string, locale: 'de' | 'en' = 'de'): string {
  const tz = SUPPORTED_TIMEZONES.find((t) => t.value === timezone);
  if (!tz) {
    return timezone;
  }
  return locale === 'de' ? tz.label : tz.labelEn;
}
